import React from 'react'
import styled from 'styled-components'
import Page from '../components/Page'
import { Container, Section, BackgroundImage, Flex } from '../components/common'
import Content from '../components/Content'

const Header = styled(Section)`
  font-weight: 400;
  font-size: 1.8rem;
`
const Logo = styled.img.attrs({
  src: `${process.env.PUBLIC_URL}/gcb_logo.png`,
  alt: 'Gold Coast Botany'
})`
  max-width: 80%;
  margin-bottom: 2rem;
`
const Columns = styled(Flex)`
  flex-direction: column;

  h1 {
    a {
      text-decoration: none;
    }
  }

  & > * {
    margin-bottom: 2rem;
  }

  @media (min-width: 777px) {
    flex-direction: row;

    & > * {
      width: 33.33%;
      padding: 0 1rem;
    }
  }
`

export default ({ title, data }) => {
  const image = data.image
  return (
    <Page>
      <Header dark relative thick>
        <BackgroundImage image={image} opacity={0.7} />
        <Container relative taCenter skinnier>
          <Logo />
          <Content source={data.blurb} />
        </Container>
      </Header>
      <Section>
        <Container>
          <Columns alignStart>
            <Content source={data.section_1} />
            <Content source={data.section_2} />
            <Content source={data.section_3} />
          </Columns>
        </Container>
      </Section>
    </Page>
  )
}



// WEBPACK FOOTER //
// ./src/views/Home.js